var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBombsam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#47ABFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1369",
    transform: "matrix(1.282890135990935,0,0,1.282890135990935,-14.145147892258448,-14.145146668799075)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.7,113.6c-201.8,0-365.4,163.6-365.4,365.4c0,115.2,53.3,217.8,136.6,284.8l-136.6,80.6h365.4 c201.8,0,365.4-163.6,365.4-365.4C844.1,277.1,680.5,113.6,478.7,113.6z M478.7,811.8H234.6l77.3-44.9c-99.2-57.6-166-165-166-288 c0-183.8,149-332.9,332.9-332.9s332.9,149,332.9,332.9C811.6,662.8,662.6,811.8,478.7,811.8z M367.8,577.6c5.4,5.4,5.4,14.3,0,19.7 c-5.4,5.4-14.3,5.4-19.7,0L239.8,489c-5.4-5.4-5.4-14.3,0-19.7l108.3-108.3c5.4-5.4,14.3-5.4,19.7,0c5.4,5.4,5.4,14.3,0,19.7 l-98.4,98.4L367.8,577.6 M589.7,380.8c-5.4-5.4-5.4-14.3,0-19.7c5.4-5.4,14.3-5.4,19.7,0l108.3,108.3c5.4,5.4,5.4,14.3,0,19.7 L609.4,597.3c-5.4,5.4-14.3,5.4-19.7,0c-5.4-5.4-5.4-14.3,0-19.7l98.4-98.4L589.7,380.8 M427.1,606.1c-1.9,0-3.9-0.4-5.8-1.3 c-7-3.2-10.1-11.5-6.9-18.5l103.2-226.4c3.2-7,11.4-10.1,18.4-6.9c7,3.2,10.1,11.4,6.9,18.5L439.8,597.9 C437.5,603.1,432.4,606.1,427.1,606.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombsam);
export default __webpack_public_path__ + "static/media/bombsam.4cd5088096346e4544a661e3d222db96.svg";
export { ForwardRef as ReactComponent };